import React from 'react';
import { AlertTriangle, XCircle, Flame, Brain, Scale } from 'lucide-react';
export function ProblemSection() {
  const failures = ['Dietas restrictivas que te dan más ansiedad.', 'Pastillas mágicas que solo te deshidratan.', 'Horas de cardio que elevan aún más tu estrés.', 'Ignorar el problema esperando que se pase solo.'];
  return <section className="px-4 py-10 max-w-md mx-auto" data-id="element-101">
      <div className="text-center mb-8" data-id="element-102">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-red-100 text-red-500 rounded-full mb-4" data-id="element-103">
          <AlertTriangle className="w-6 h-6" data-id="element-104" />
        </div>
        <h2 className="text-2xl font-bold text-darkslate mb-3" data-id="element-105">
          El enemigo invisible: La Inflamación por Estrés
        </h2>
        <p className="text-gray-600 text-sm" data-id="element-106">
          Cuando vivís estresado, tu cuerpo libera Cortisol sin parar. Esto le
          dice a tu organismo:{' '}
          <strong data-id="element-107">
            "Almacená grasa en el abdomen y frená el metabolismo".
          </strong>
        </p>
      </div>

      <div className="space-y-4 mb-10" data-id="element-108">
        <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-109">
          <div className="bg-sage/20 p-2 rounded-lg text-sage-dark mt-1" data-id="element-110">
            <Flame className="w-5 h-5" data-id="element-111" />
          </div>
          <div data-id="element-112">
            <h3 className="font-bold text-darkslate" data-id="element-113">Inflamación Crónica</h3>
            <p className="text-sm text-gray-600" data-id="element-114">
              Tu intestino se inflama, causando esa sensación de "globo"
              constante.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-115">
          <div className="bg-sage/20 p-2 rounded-lg text-sage-dark mt-1" data-id="element-116">
            <Brain className="w-5 h-5" data-id="element-117" />
          </div>
          <div data-id="element-118">
            <h3 className="font-bold text-darkslate" data-id="element-119">Niebla Mental</h3>
            <p className="text-sm text-gray-600" data-id="element-120">
              Falta de concentración y olvidos frecuentes por el agotamiento
              adrenal.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-121">
          <div className="bg-sage/20 p-2 rounded-lg text-sage-dark mt-1" data-id="element-122">
            <Scale className="w-5 h-5" data-id="element-123" />
          </div>
          <div data-id="element-124">
            <h3 className="font-bold text-darkslate" data-id="element-125">Grasa Rebelde</h3>
            <p className="text-sm text-gray-600" data-id="element-126">
              El cortisol alto bloquea la quema de grasa, especialmente en la
              zona abdominal.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-darkslate text-white p-6 rounded-3xl" data-id="element-127">
        <h3 className="text-xl font-bold mb-4 text-center" data-id="element-128">
          Por qué falló lo que intentaste:
        </h3>
        <ul className="space-y-3" data-id="element-129">
          {failures.map((item, index) => <li key={index} className="flex items-start gap-3 text-sm" data-id="element-130">
              <XCircle className="w-5 h-5 text-red-400 shrink-0" data-id="element-131" />
              <span className="text-gray-300" data-id="element-132">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}